import React, { useContext, useEffect, useState } from "react";
import { CustomersContext } from "../providers/CustomersProvider";
import { useParams } from "react-router-dom";
import { customersRef } from "../firebase";
import Footer from "./Footer";
import "../css/settingsForm.scss";
import { doc, updateDoc } from "firebase/firestore";

const CustomersForm = () => {
  const customersData = useContext(CustomersContext);
  const [customerData, setCustomerData] = useState({});
  const params = useParams();

  useEffect(() => {
    const customer = customersData.find(
      (customer) => customer.uid === params.uid
    );
    setCustomerData(customer);
  }, [customersData, params.uid]);

  const inputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    updateDoc(doc(customersRef, params.uid), { [name]: value });
  };

  return (
    <div className="settingsFormPage">
      <Footer title={"Customers"} back={true}>
        {/* <button onClick={addJobDescription} className="adder">
          @
        </button> */}
      </Footer>
      <form className="settingsForm">
        <div className="formLine">
          <label htmlFor="name">Name</label>
          <input
            value={customerData?.name ?? ""}
            id="name"
            name="name"
            onChange={inputHandler}
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="accessId">Access Id</label>
          <input
            value={customerData?.accessId ?? ""}
            id="accessId"
            name="accessId"
            onChange={inputHandler}
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="housing">Housing</label>
          <input
            value={customerData?.housing ?? ""}
            id="housing"
            name="housing"
            onChange={inputHandler}
            type="text"
          />
        </div>
        {/* <label htmlFor="secondaryCustomer">
        <input id="secondaryCustomer" name="secondaryCustomer" type="text" />
      </label> */}
        <div className="formLine">
          <label htmlFor="address">Address line 1</label>
          <input
            value={customerData?.address ?? ""}
            id="address"
            name="address"
            onChange={inputHandler}
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="address2">Address line 2</label>
          <input
            value={customerData?.address2 ?? ""}
            id="address2"
            name="address2"
            type="text"
            onChange={inputHandler}
          />
        </div>
        <div className="formLine">
          <label htmlFor="authorisedBy">Authorised by</label>
          <input
            value={customerData?.authorisedBy ?? ""}
            id="authorisedBy"
            name="authorisedBy"
            onChange={inputHandler}
            type="text"
          />
        </div>
        <div className="formLine">
          <label htmlFor="city">City</label>
          <input
            value={customerData?.city ?? ""}
            id="city"
            name="city"
            onChange={inputHandler}
            type="text"
          />
        </div>
        <div className="formLine">
          <label htmlFor="email">Email</label>
          <input
            value={customerData?.email ?? ""}
            id="email"
            onChange={inputHandler}
            name="email"
            type="text"
          />
        </div>
        <div className="formLine">
          <label htmlFor="number">Number</label>
          <input
            value={customerData?.number ?? ""}
            id="number"
            name="number"
            type="text"
            onChange={inputHandler}
          />
        </div>
        <div className="formLine">
          <label htmlFor="flat">Flat</label>
          <input
            value={customerData?.flat ?? ""}
            id="flat"
            name="flat"
            onChange={inputHandler}
            type="text"
          />
        </div>
        <div className="formLine">
          <label htmlFor="postcode">Postcode</label>
          <input
            value={customerData?.postcode ?? ""}
            id="postcode"
            name="postcode"
            type="text"
            onChange={inputHandler}
          />
        </div>
        <div className="formLine">
          <label htmlFor="unit">Unit</label>
          <input
            value={customerData?.unit ?? ""}
            id="unit"
            name="unit"
            onChange={inputHandler}
            type="text"
          />
        </div>
      </form>
    </div>
  );
};

export default CustomersForm;
